<template>
  <div class="hello">
    <div v-if="colorname === 'VI'">
    <b-badge class="custom-bg-vi">VI</b-badge></div>
    <div v-else-if="colorname === 'BL'"><b-badge class="custom-bg-bl">BL</b-badge></div>
    <div v-else-if="colorname === 'BR'"><b-badge class="custom-bg-br">BR</b-badge></div>
    <div v-else-if="colorname === 'GR'"><b-badge class="custom-bg-gr">GR</b-badge></div>
    <div v-else-if="colorname === 'SV'"><b-badge class="custom-bg-black">SV</b-badge></div>
    <div v-else-if="colorname === 'GRÅ'"><b-badge class="custom-bg-grey">GRÅ</b-badge></div>
    <div v-else-if="colorname === 'OR'"><b-badge class="custom-bg-or">OR</b-badge></div>
    <div v-else-if="colorname === 'RÖ'"><b-badge class="custom-bg-red">RÖ</b-badge></div>
    <div v-else-if="colorname === 'VL'"><b-badge class="custom-bg-vl">VL</b-badge></div>
    <div v-else-if="colorname === 'RO'"><b-badge class="custom-bg-pink">RO</b-badge></div>
    <div v-else-if="colorname === 'TU'"><b-badge class="custom-bg-tu">TU</b-badge></div>
  </div>
</template>

<script>
  export default {
    name: 'Badge',

    //scoped variables in this component
    data () {
      return { }
    },

    // observed variables (by function)
    computed: { },

    // functions firing by template
    methods: { },

    // child components this component calls
    components: { },

    // variables passed from parent template
    props: { },

    // Lifecycle hooks
    created () { },
    mounted () { },
    updated () { },
    destroyed () { },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">
  h1, h2 {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Badge.vue